/**
 * Stripe Buy Button — official embedded checkout button from Stripe.
 * The <script src="https://js.stripe.com/v3/buy-button.js"> is loaded
 * globally from /public/index.html so <stripe-buy-button> is defined
 * as a custom element by the time this renders.
 */
export default function StripeBuyButton({ className = "" }) {
  return (
    <div
      data-testid="stripe-buy-button-wrapper"
      className={`w-full flex justify-center ${className}`}
    >
      <stripe-buy-button
        buy-button-id="buy_btn_1U18vdHMSwIqHQUF2ILxiero"
        publishable-key="pk_live_51TEKgtHMSwIqHQUF9tynj4wqqfc0YrhyjUq3LQzXhHHmDdDccE8KAE4OHWvYAuTNi6vTIdFNh0KBBHGlfmvRA6nF00neq2xaJJ"
      ></stripe-buy-button>
    </div>
  );
}
